<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const successNotification = computed(() => store.state.successNotification);
const errorNotification = computed(() => store.state.errorNotification);
const closeAlert = () => {
  store.commit("clearNotifications");
};
</script>
<template>
  <div class="text-white px-4 py-3 rounded d-flex align-items-center justify-content-between sucess-message"
    :class="successNotification ? 'bg-success' : 'bg-error'" v-if="successNotification || errorNotification">
    <div class="d-flex align-items-start">
      <i class="fas fa-info-circle me-2"></i>
      <div :class="successNotification ? 'ctm-sucess' : 'ctm-error'">
        <h4 class="mb-0">{{ successNotification ? 'Success' : 'Error' }}</h4>
        <span>{{ successNotification || errorNotification }}</span>
      </div>
    </div>
    <button class="text-white hover:text-gray-200" @click="closeAlert">
      <i class="fas fa-times"></i>
    </button>
  </div>
  <footer class="py-3 footer">
    <div class="container-fluid">
      <div class="row align-items-center justify-content-lg-between">
        <div class="mb-4 col-lg-12 mb-lg-0">
          <div class="text-sm text-center copyright text-muted"
            :class="store.state.isRTL ? 'text-lg-end' : 'text-lg-center'">
            Copyright @ 2025 Shipping Quote Automation All Rights Reserved.
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<style>
/* .footer{
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
} */
</style>
